import React, { useEffect, useState, useRef } from 'react'
import Page from '../../../../component/Page'
import { addMaterialsReceive, getBranchList, getBudgetYearsList, getDepartmentsList, getMaterialsList } from '../../services/api'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import TitlePage from '../../../../component/TitlePage'
import { Autocomplete, Box, Button, FormControl, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material'
import dayjs from 'dayjs'
import DatePicker from '../../../../component/DatePicker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faMinusCircle, faPlusCircle, faUpload } from '@fortawesome/free-solid-svg-icons'
import ConfirmDialog from '../component/ConfirmDialog'
import { useSelector } from 'react-redux'
import api from "../../../../api/api";
import axios from "axios";
import Swal from "sweetalert2";
export default function MaterialsReceiveAdd() {
  const navigate = useNavigate();
  const location = useLocation()
  const fileRef = useRef()
  const [importExcel, setImportExcel] = useState(false);

  const { profile } = useSelector(state => state.profile)
  const { id } = useParams()
  const [open, setOpen] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [branchs, setBranchs] = useState([])
  const [budgetYears, setBudgetYears] = useState([])
  const [materials, setMaterials] = useState([])
  const [departments, setDepartments] = useState([])
  const [receiveDate, setReceiveDate] = useState(dayjs(new Date()))
  const [branchNo, setBranchNo] = useState('')
  const [branchNoError, setBranchNoError] = useState(false)
  const [departmentName, setDepartmentName] = useState('')
  const [departmentNameError, setDepartmentNameError] = useState(false)
  const [rows, setRows] = useState([
    {
      RefNo: "",
      ItemNo: null,
      BudgetYear: 0,
      BudgetType: "เงินงบประมาณ",
      Lot: "",
      Qty: 0,
      UnitNo: "",
      CostPrice: 0,
      Width: "",
      Length: "",
      Thick: "",
      Status: "พร้อมใช้งาน",
      Remark: ""
    }
  ])
  function addRow() {
    const newRow = {
      RefNo: "",
      ItemNo: null,
      BudgetYear: 0,
      BudgetType: "เงินงบประมาณ",
      Lot: "",
      Qty: 0,
      UnitNo: "",
      CostPrice: 0,
      Width: "",
      Length: "",
      Thick: "",
      Status: "พร้อมใช้งาน",
      Remark: ""
    }

    setRows([...rows, newRow]);
  }
  useEffect(() => {
    if (location.state) {
      setRows([
        {
          RefNo: "",
          ItemNo: {
            ItemNo: location.state?.ItemNo,
            ItemName: location.state?.ItemName,
          },
          BudgetYear: location.state?.BudgetYear,
          BudgetType: location.state?.BudgetType,
          Lot: "",
          Qty: 0,
          UnitNo: { 
            UnitNo: location.state?.UnitNo,
            UnitName: location.state?.UnitName
           },
          CostPrice: 0,
          Width: "",
          Length: "",
          Thick: "",
          Status: "พร้อมใช้งาน",
          Remark: ""
        }
      ])
    }
  }, [location.state])

  const deletehand = (i) => {
    const data = rows?.filter((e, index) => i !== index);
    setRows(data);
  };
  useEffect(() => {
    const getBranch = async () => {
      const data = await getBranchList()
      setBranchs(data)
    }
    const getDepartments = async () => {
      const data = await getDepartmentsList()
      setDepartments(data)
    }
    const getBudgetYears = async () => {
      const data = await getBudgetYearsList()
      setBudgetYears(data)
    }
    const getMaterials = async () => {
      const data = await getMaterialsList()
      setMaterials(data)
    }
    getBranch()
    getDepartments()
    getBudgetYears()
    getMaterials()
    setBranchNo(profile?.BranchNo?.BranchNo)

  }, [])

  const handleSubmit = async () => {
    const body = {
      DocumentDate: dayjs(receiveDate).format('YYYY-MM-DD'),
      BranchNo: branchNo,
      DepartmentName: departmentName,
      Status: "Y",
      Details: rows?.map((item) => ({
        RefNo: item?.RefNo,
        ItemNo: item?.ItemNo?.ItemNo,
        BudgetYear: item?.BudgetYear,
        BudgetType: item?.BudgetType,
        Lot: item?.Lot,
        Qty: item?.Qty.toString().replaceAll(',', ''),
        UnitNo: item?.UnitNo?.UnitNo,
        CostPrice: item?.CostPrice,
        Width: item?.RequireSize ? item?.Width : '',
        Length: item?.RequireSize ? item?.Length : '',
        Thick: item?.RequireSize ? item?.Thick : '',
        Status: item?.Status,
        Remark: item?.Remark

      }))
    }
    const post = async () => {
      setLoadingSubmit(true)
      const res = await addMaterialsReceive(body)
      if (res) {
        setLoadingSubmit(false)
        setOpen(false)
        navigate('/materials/materials-receive/' + res.DocumentNo, { state: { new: true } })
      }
    }
    post()
  }
  async function importReceives(_file) {
    const frmData = new FormData();
    frmData.append("file", _file);
    const res = await api.post(`material/import-receives`, frmData);
    const data = await res.data.result;
    if (res.data.status === true) {
      Swal.fire({
        title: "อัพโหลดสำเร็จ",
        icon: "success",
      });
      const creds = [];

      for (const c of data) {
          creds.push({...c, ItemNo: materials.find((x) => x.ItemNo === c.ItemNo), UnitNo: materials.find((x) => x.ItemNo === c.ItemNo).UnitNo});
          setRows(creds)
    }
}
  }
  async function uploadFile(event) {
    setImportExcel(true);
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileUpload = file;
      if (
        fileUpload?.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setImportExcel(false);
        return alert("กรุณาอัพโหลดไฟล์ excel");
      }

      await importReceives(fileUpload);
    }
    event.target.value = "";
    setImportExcel(false);
  }
  return (
    <Page>
      <TitlePage title='รายละเอียดการรับวัสดุคงคลัง' />
      <Box class="row">
        <Box className="col-lg-4 col-md-6">
          <Typography className="labelInput">วันรับวัสดุ</Typography>
          <DatePicker value={receiveDate} onChange={e => setReceiveDate(e)} disabled={id ? true : false} />
        </Box>
      </Box>
      <Box class="row">
        <Box class="col-lg-4 col-md-6" style={{ marginBottom: '10px' }}>
          <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
          <Box className={`backgroundField ${branchNoError ? 'error' : ''}`}>
            <FormControl variant="standard" fullWidth disabled={id ? true : false}>
              <Select value={branchNo || ''} onChange={e => {
                setBranchNo(e.target.value)
              }} disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                onBlur={e => {
                  if (!e.target.value) {
                    setBranchNoError(true)
                  } else {
                    setBranchNoError(false)
                  }
                }}
              >
                {branchs?.filter(item => profile?.BranchNo?.BranchNo === '00' ? item : item?.BranchNo === profile?.BranchNo?.BranchNo).map((x) => (
                  <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {branchNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกศูนย์เมล็ดพันธุ์ข้าว</span>}

        </Box>
        <div class="col-lg-4 col-md-6" style={{ marginBottom: '10px' }}>
          <label class="labelInput">หน่วยงานที่รับ</label>
          <Box className={`backgroundField ${departmentNameError ? 'error' : ''}`}>
            <FormControl variant="standard" fullWidth disabled={id ? true : false}>
              <Select value={departmentName || ''} onChange={e => {
                setDepartmentName(e.target.value)
              }} disableUnderline
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                onBlur={e => {
                  if (!e.target.value) {
                    setDepartmentNameError(true)
                  } else {
                    setDepartmentNameError(false)
                  }
                }}
              >
                {departments?.map((x) => (
                  <MenuItem value={x?.DepartmentName}>{x?.DepartmentName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {departmentNameError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกหน่วยงานที่รับ</span>}

        </div>
      </Box>


      <TitlePage title='รายการรับวัสดุ' action={
         <div
         class="col-md-8 col-sm-12 text-end"
         style={{
           display: "flex",
           alignItems: "center",
           justifyContent: "end",
         }}
       >
         <input
           type="file"
           ref={fileRef}
           accept=".xlsx,.csv,.xls"
           hidden
           onChange={uploadFile}
         />
         <Button
           variant="outlined"
           onClick={() => fileRef.current.click()}
           startIcon={<FontAwesomeIcon icon={faUpload} />}
           sx={{ width: "180px", fontSize: "14px", marginRight: "10px" }}
         >
           อัพโหลด Excel
         </Button>
         <FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />
       </div>
      } />
      <div class="addDetail row">
        <div class="col-md-12 table-responsive-sm" style={{ height: 'auto' }}>
          <table class="table table-borderless">
            <thead>
              <tr>
                <th class="text-center" >ที่</th>
                <th class="text-center">เอกสารที่อ้างถึง</th>
                <th class="text-center" >รายการ</th>
                <th class="text-center" >ปีงบประมาณ</th>
                <th class="text-center" >ประเภทเงิน</th>
                <th class="text-center" >เลขครุภัณฑ์</th>
                <th class="text-center" >ปริมาณ</th>
                <th class="text-center" >หน่วย</th>
                <th class="text-center" >กว้าง (เมตร) </th>
                <th class="text-center" >ยาว (เมตร)</th>
                <th class="text-center" >หนา (มิลลิเมตร)</th>
                <th class="text-center" >ราคา/หน่วย (บาท)</th>
                <th class="text-center" >สถานะ</th>
                <th class="text-center" >หมายเหตุ</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="">
              {rows?.map((item, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1} .</td>
                    <td>
                      <TextField
                        value={item?.RefNo || ''}
                        onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.RefNo = i === index ? e.target.value : v?.RefNo;
                            return v;

                          });
                          setRows([...newItem]);
                        }}
                        sx={{ background: '#fff', width: '100%' }}
                        size='small' variant='outlined'
                      // onKeyPress={(event) => {
                      //   if (!/[0-9]/.test(event.key)) {
                      //     event.preventDefault();
                      //   }
                      // }}
                      />
                    </td>
                    <td>
                      <Autocomplete
                        size='small'
                        options={materials}
                        getOptionLabel={(option) => option?.ItemName}
                        onBlur={e => {
                          const newItem = rows?.map((v, index) => {
                            v.itemError = index === i ? item.ItemNo ? false : true : v?.itemError;
                            return v;

                          });
                          setRows([...newItem]);
                        }
                        }
                        componentsProps={{
                          paper: {
                            sx: {
                              width: 500
                            }
                          }
                        }}
                        renderOption={(props, option) => (
                          <Box component="li" {...props} key={option.ItemNo}>
                            {option?.ItemName} {option?.UnitNo?.UnitName}
                          </Box>
                        )}
                        value={item?.ItemNo}
                        onChange={(event, newValue) => {
                          const newItem = rows?.map((v, index) => {
                            v.ItemNo = index === i ? newValue : v?.ItemNo;
                            v.UnitNo = index === i ? newValue?.UnitNo : v?.UnitNo
                            v.Width = index === i ? '' : v?.Width
                            v.Length = index === i ? '' : v?.Length
                            v.Thick = index === i ? '' : v?.Thick
                            v.RequireSize = index === i ? newValue?.CatalogNo?.RequireSize : v?.RequireSize
                            return v;

                          });
                          setRows([...newItem]);

                        }}

                        renderInput={(params) => (
                          <Box ref={params.InputProps.ref}>
                            <OutlinedInput error={item?.ItemNo ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: '#fff' }} />
                          </Box>
                        )}
                      />
                    </td>
                    <td>
                      <FormControl variant="outlined" size='small' fullWidth
                        error={!item?.BudgetYear}
                      >
                        <Select value={item?.BudgetYear} onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.BudgetYear = i === index ? e.target.value : v?.BudgetYear;
                            return v;

                          });
                          setRows([...newItem]);
                        }} onBlur={e => {
                          const newItem = rows?.map((v, index) => {
                            v.BudgetYearError = index === i ? item.BudgetYear ? false : true : v?.BudgetYearError;
                            return v;

                          });
                          setRows([...newItem]);
                        }} >
                          {budgetYears?.map((z, i) => (
                            <MenuItem key={i} value={z?.BudgetYear}>{z?.BudgetYear}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </td>
                    <td>
                      <FormControl variant="outlined" size='small' fullWidth
                        error={item?.BudgetTypeError}
                      >
                        <Select value={item?.BudgetType} onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.BudgetType = i === index ? e.target.value : v?.BudgetType;
                            return v;

                          });
                          setRows([...newItem]);
                        }} onBlur={e => {
                          const newItem = rows?.map((v, index) => {
                            v.BudgetTypeError = index === i ? item.BudgetType ? false : true : v?.BudgetTypeError;
                            v.Lot = i === index ? e.target.value === 'เงินทุนหมุนเวียนฯ' ? '' : v?.Lot : v?.Lot

                            return v;

                          });
                          setRows([...newItem]);
                        }} >
                          <MenuItem value='เงินงบประมาณ'>เงินงบประมาณ</MenuItem>
                          <MenuItem value='เงินทุนหมุนเวียนฯ'>เงินทุนหมุนเวียนฯ</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                    <td>
                      <TextField
                        value={item?.Lot || ''}
                        sx={{ background: '#fff', width: '100%' }}
                        error={item?.BudgetType === 'เงินงบประมาณ' && !item?.Lot}
                        onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.Lot = i === index ? e.target.value : v?.Lot;
                            return v;

                          });
                          setRows([...newItem]);
                        }}
                        size='small' variant='outlined'
                      // onKeyPress={(event) => {
                      //   if (!/[0-9]/.test(event.key)) {
                      //     event.preventDefault();
                      //   }
                      // }}
                      />
                    </td>
                    <td>
                      <TextField
                        value={item?.Qty?.toLocaleString() || ''}
                        sx={{ background: '#fff', width: '100%' }}
                        onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            let newValue = e.target.value.replace(/,/g, "");
                            let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                            v.Qty = i === index ? abc : v?.Qty;
                            return v;

                          });
                          setRows([...newItem]);
                        }}
                        size='small' variant='outlined'
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }} />
                    </td>
                    <td>
                      <TextField
                        value={item?.UnitNo?.UnitName || ''}
                        sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                        InputProps={{
                          readOnly: id ? true : false
                        }}
                        size='small' variant='outlined'
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }} />
                    </td>
                    <td>
                      <TextField
                        value={item?.Width || ''}
                        sx={{ background: !item?.RequireSize ? '#e9ecef' : '#fff', width: '100%' }}
                        type='number'
                        disabled={!item?.RequireSize}
                        error={item?.RequireSize && !item?.Width}
                        onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.Width = i === index ? e.target.value > 99.99 ? 99.99 : e.target.value : v?.Width;
                            return v;

                          });
                          setRows([...newItem]);
                        }}
                        size='small' variant='outlined'
                      />
                    </td>
                    <td>
                      <TextField
                        value={item?.Length || ''}
                        sx={{ background: !item?.RequireSize ? '#e9ecef' : '#fff', width: '100%' }}
                        type='number'
                        disabled={!item?.RequireSize}
                        error={item?.RequireSize && !item?.Length}
                        onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.Length = i === index ? e.target.value > 99.99 ? 99.99 : e.target.value : v?.Length;
                            return v;

                          });
                          setRows([...newItem]);
                        }}
                        size='small' variant='outlined'
                      />
                    </td>
                    <td>
                      <TextField
                        value={item?.Thick || ''}
                        sx={{ background: !item?.RequireSize ? '#e9ecef' : '#fff', width: '100%' }}
                        type='number'
                        disabled={!item?.RequireSize}
                        error={item?.RequireSize && !item?.Thick}
                        onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.Thick = i === index ? e.target.value > 99.99 ? 99.99 : e.target.value : v?.Thick;
                            return v;

                          });
                          setRows([...newItem]);
                        }}
                        size='small' variant='outlined'
                      />
                    </td>
                    <td>
                      <TextField
                        value={item?.CostPrice?.toLocaleString() || ''}
                        sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                        type='number'
                        onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.CostPrice = i === index ? e.target.value : v?.CostPrice;
                            return v;

                          });
                          setRows([...newItem]);
                        }}
                        size='small' variant='outlined'
                      />
                    </td>
                    <td>
                      <FormControl variant="outlined" size='small' fullWidth
                      >
                        <Select value={item?.Status} onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.Status = i === index ? e.target.value : v?.Status;
                            return v;

                          });
                          setRows([...newItem]);
                        }} >
                          <MenuItem value='พร้อมใช้งาน'>พร้อมใช้งาน</MenuItem>
                          <MenuItem value='ชำรุด-รอซ่อม'>ชำรุด-รอซ่อม</MenuItem>
                          <MenuItem value='ชำรุด-ตัดบัญชี'>ชำรุด-ตัดบัญชี</MenuItem>
                        </Select>
                      </FormControl>
                    </td>
                    <td>
                      <TextField
                        value={item?.Remark || ''}
                        sx={{ background: '#fff', width: '100%' }}
                        onChange={e => {
                          const newItem = rows?.map((v, index) => {
                            v.Remark = i === index ? e.target.value : v?.Remark;
                            return v;

                          });
                          setRows([...newItem]);
                        }}
                        size='small' variant='outlined'
                      />
                    </td>
                    <td>
                      {rows.Length < 2 || i === 0 ? null : <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
      <hr class="chr" />
      <div class="row mt-4">
        <div class="col-12">
          <Button onClick={() => navigate(-1)} variant='outlined'
            startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
            sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
          <Button variant='contained' onClick={() => {
            if (branchNo) {
              if (departmentName) {
                if (rows.filter(item => item?.BudgetType === 'เงินงบประมาณ' && !item?.Lot).length === 0 &&
                  rows.filter(item => !item?.ItemNo).length === 0 &&
                  rows.filter(item => !item?.BudgetYear).length === 0) {

                  if (rows.filter(item => item?.RequireSize).length > 0 &&
                    rows.filter(item => item?.RequireSize).filter(item => !item?.Width).length === 0 &&
                    rows.filter(item => item?.RequireSize).filter(item => !item?.Length).length === 0 &&
                    rows.filter(item => item?.RequireSize).filter(item => !item?.Thick).length === 0) {
                    setOpen(true)
                  }
                  if (rows.filter(item => item?.RequireSize).length === 0) {
                    setOpen(true)
                  }
                  else {

                  }
                }
              } else {
                setDepartmentNameError(true)

              }
            } else {
              setBranchNoError(true)
              if (departmentName) {
                setDepartmentNameError(false)
              } else {
                setDepartmentNameError(true)
              }
            }

          }} sx={{ width: '130px', fontSize: '14px' }}>บันทึก</Button>

        </div>
      </div>
      <ConfirmDialog open={open} setOpen={setOpen} rows={rows} handleSubmit={handleSubmit} loadingSubmit={loadingSubmit} />
    </Page>
  )
}
